import { Link } from 'react-router-dom';

const LOGO_URL = 'https://storage.readdy-site.link/project_files/592e1909-dcd7-4362-8690-bb74ab41b6ab/f375b2c6-56db-4985-a2be-b4997b3e6fa9_khalsa-logo.png?v=f29e87db227a305ed53a3978955c97c9';

const pageLinks = [
  { label: 'Services', href: '/services' },
  { label: 'About', href: '/about' },
  { label: 'Locations', href: '/locations' },
];

const services = [
  'Holistic Healing Therapy',
  'Energy Work & Bodywork',
  'Trauma Release',
  'Nervous System Reset',
  'Personalized Sessions',
];

const socials = [
  { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/khalsahealing/', label: 'Facebook' },
  { icon: 'ri-instagram-line', href: 'https://www.instagram.com/mahanrishikhalsahealingarts/', label: 'Instagram' },
  { icon: 'ri-twitter-x-line', href: 'http://www.twitter.com/khalsahealing', label: 'Twitter' },
];

export default function Footer() {
  const scrollToBooking = () => {
    const el = document.getElementById('booking');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#050505] border-t border-[#d4af37]/10">
      {/* Top strip */}
      <div className="border-b border-[#d4af37]/8 py-12">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-[#6a6a6a] text-xs uppercase tracking-[0.2em] mb-1" style={{ fontFamily: 'Inter, sans-serif' }}>
              Begin Your Healing Journey
            </p>
            <p className="text-white text-xl font-light" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Serving Yardley & Bucks County with personalized healing sessions
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <button
              onClick={scrollToBooking}
              className="bg-[#d4af37] hover:bg-[#c09b2a] text-[#080808] px-8 py-3 rounded-full text-xs uppercase tracking-[0.15em] font-semibold transition-all cursor-pointer whitespace-nowrap"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Book a Session
            </button>
            <a
              href="tel:+12153210305"
              className="border border-[#d4af37]/30 hover:border-[#d4af37] text-[#d4af37] px-8 py-3 rounded-full text-xs uppercase tracking-[0.15em] transition-all cursor-pointer whitespace-nowrap text-center"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Call Now
            </a>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-5 cursor-pointer">
              <img
                src={LOGO_URL}
                alt="Khalsa Healing Arts & Yoga Center"
                className="h-14 w-auto object-contain"
              />
            </Link>
            <p className="text-[#5a5a5a] text-sm leading-relaxed mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
              Advanced holistic healing services in Yardley, PA. Personalized care designed for lasting transformation.
            </p>
            <div className="flex gap-3">
              {socials.map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-[#2a2a2a] hover:border-[#d4af37]/40 text-[#5a5a5a] hover:text-[#d4af37] transition-all cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Pages */}
          <div>
            <h4 className="text-[#d4af37] uppercase tracking-[0.2em] text-[10px] mb-5" style={{ fontFamily: 'Inter, sans-serif' }}>
              Pages
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#5a5a5a] hover:text-[#d4af37] text-sm transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Home
                </Link>
              </li>
              {pageLinks.map((p) => (
                <li key={p.href}>
                  <Link to={p.href} className="text-[#5a5a5a] hover:text-[#d4af37] text-sm transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {p.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#d4af37] uppercase tracking-[0.2em] text-[10px] mb-5" style={{ fontFamily: 'Inter, sans-serif' }}>
              Services
            </h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s}>
                  <Link to="/services" className="text-[#5a5a5a] hover:text-[#d4af37] text-sm transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#d4af37] uppercase tracking-[0.2em] text-[10px] mb-5" style={{ fontFamily: 'Inter, sans-serif' }}>
              Contact
            </h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:+12153210305" className="flex items-center gap-3 group cursor-pointer">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#d4af37]/10 group-hover:bg-[#d4af37]/20 transition-colors flex-shrink-0">
                    <i className="ri-phone-line text-[#d4af37] text-xs" />
                  </div>
                  <span className="text-[#5a5a5a] group-hover:text-[#d4af37] text-sm transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>
                    215-321-0305
                  </span>
                </a>
              </li>
              <li>
                <a href="mailto:events@khalsahealingarts.com" className="flex items-center gap-3 group cursor-pointer">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#d4af37]/10 group-hover:bg-[#d4af37]/20 transition-colors flex-shrink-0">
                    <i className="ri-mail-line text-[#d4af37] text-xs" />
                  </div>
                  <span className="text-[#5a5a5a] group-hover:text-[#d4af37] text-sm transition-colors break-all" style={{ fontFamily: 'Inter, sans-serif' }}>
                    events@khalsahealingarts.com
                  </span>
                </a>
              </li>
              <li>
                <a
                  href="https://goo.gl/maps/SVdvMdaAHKqbRmd18"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-start gap-3 group cursor-pointer"
                >
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#d4af37]/10 group-hover:bg-[#d4af37]/20 transition-colors flex-shrink-0 mt-0.5">
                    <i className="ri-map-pin-line text-[#d4af37] text-xs" />
                  </div>
                  <span className="text-[#5a5a5a] group-hover:text-[#d4af37] text-sm leading-snug transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>
                    90 West Afton Ave. #204<br />
                    Yardley, PA 19067<br />
                    <span className="text-[#3a3a3a] text-xs">Big Pink Building</span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#d4af37]/8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#2a2a2a] text-xs" style={{ fontFamily: 'Inter, sans-serif' }}>
            &copy; {new Date().getFullYear()} Khalsa Healing Arts &amp; Yoga Center · Yardley, PA. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {['Yardley', 'Newtown', 'Langhorne', 'New Hope'].map((city) => (
              <Link key={city} to="/locations" className="text-[#2a2a2a] hover:text-[#d4af37]/50 text-xs transition-colors cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                {city}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
